<template>
  <div class="present-vip-btn" @click="presentVipClick" :class="size" :style="styleConfig">
    <img :src="config.bg">
    <div v-if="config.point" class="point"><img :src="config.point"></div>
    <svg-icon v-show="presentVipSelected && config.point" class="present-selected" :icon-class="config.iconClass || 'gf_select_icon'"  :style="`color:${config.color};`" />
  </div>
</template>
<script>
import giveFriend from '@/mixins/giveFriend';

export default {
  mixins: [giveFriend],
  computed: {
    styleConfig() {
      return {
         '--point-position': this.config.topPosition || '2.4vw',
         '--point-position-left': this.config.leftPosition || '6.667vw',
         '--selected-position-left': this.config.leftSelected || '1.333vw',
         '--point-margin': this.config.pointMargin || '2vw auto 1.067vw',
         '--point-width': this.config.pointWidth || '10.8vw',
         '--point-height': this.config.pointHeight || '3.2vw',
         '--icon-width': this.config.iconWidth || '5.067vw',
         '--icon-height': this.config.iconHeight || '3.733vw',
         '--icon-top': this.config.iconTop || '2.4vw',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  .present-vip-btn {
    width: 533px;
    height: 60px;
    margin: var(--point-margin);
    position: relative;
    .present-selected {
      position: absolute;
      left: var(--selected-position-left);
      top: var(--icon-top);
      width: var(--icon-width);
      height: var(--icon-height);
    }
    .point{
      position: absolute;
      left: var(--point-position-left);
      top: var(--point-position);
      width: var(--point-width);
      height: var(--point-height);
      animation: shakeX 2.5s linear 0s infinite normal;
      animation-fill-mode: both;
      line-height: 1;
    }
  }
  @keyframes shakeX {

  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
  }
</style>
